import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/sass/base.scss';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
